<template>
  <v-layout class="fontlao">
    <!--Drawer-->
    <v-navigation-drawer v-model="drawer" temporary>
      <v-list-item :prepend-avatar="require('../../../src/assets/logo.png')" :title="title"
        :subtitle="subtitle">
      </v-list-item>

      <v-divider></v-divider>

      <v-list density="compact" nav>
        <v-list-group v-for="(item, index) in items" :key="index" :value="item.route" :prepend-icon="item.icon"
          :append-icon="item.menus == null ? 'mdi-chevron-right' : ''">
          <template v-slot:activator="{ props }">
            <v-list-item v-if="item.menus" v-bind="props" :title="item.menu_name" />
            <v-list-item v-else v-bind="props" :title="item.menu_name" :to="item.route" />
          </template>

          <v-list-item v-for="(menu, i) in item.menus" :key="i" :title="menu.menu_name" :to="item.route + menu.route" />
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <!--Nav Bar-->
    <v-main>
      <v-app-bar absolute :height="100" color="primary" :elevation="0">
        <!-- <v-app-bar-nav-icon v-if="!hideMenu" @click.stop="drawer = !drawer" color="white" /> -->
        <template v-slot:prepend>
          <v-app-bar-nav-icon :size="50" v-if="!hideMenu" @click.stop="drawer = !drawer" color="white"></v-app-bar-nav-icon>
          <v-img v-else v-show="hideImg" :height="80" :min-height="60" :min-width="110"
            :src="require('../../../src/assets/logo.png')" />
        </template>
        <!-- <v-img v-show="hideImg" :height="80" :min-height="60" :min-width="110"
          :src="require('../../../src/assets/logo.svg')" /> -->
        <!-- <v-app-bar-title > -->
        <v-row>
          <v-col>
            <v-row class="ml-4">
              <h2>{{ title }}</h2>
            </v-row>
            <v-row v-if="hideMenu" class="ml-4 mt-2">
              <h3>{{ subtitle }}</h3>
            </v-row>
          </v-col>
        </v-row>
        <!-- </v-app-bar-title> -->


        <v-spacer></v-spacer>

        <div v-if="hideMenu" class="ml-8 mr-10">
          <v-row>
            <v-menu v-for="(item, index) in items" :key="index" offset-y>
              <template v-slot:activator="{ props }">
                <v-btn v-if="item.menus != null" text v-bind="props">
                  <!-- <v-icon class="ma-1" left :icon="item.icon" /> -->

                  {{ item.menu_name }}
                </v-btn>
                <v-btn class="f-color mx-1" v-if="item.menus == null" :to="item.route">
                  <!-- <v-icon class="ma-1" left :icon="item.icon" /> -->

                  {{ item.menu_name }}
                </v-btn>
              </template>

              <v-list v-if="item.menus">
                <v-list-item class="fontlao" v-for="(menu, i) in item.menus" :key="i" :to="item.route + menu.route"
                  :title="menu.menu_name" />
              </v-list>
            </v-menu>
          </v-row>
        </div>

        <template v-slot:append>
          <v-btn v-if="hideMenu" elevation="1" :style="{ backgroundColor: '#018786' }" variants="outlined" class="btnStyle" width="100" @click="$router.push('/login')">
            ເຂົ້າສູ່ລະບົບ
          </v-btn>
          <v-btn v-else icon @click="$router.push('/login')">
            <v-icon size="30">mdi-login</v-icon>
          </v-btn>
        </template>

      </v-app-bar>
      <router-view />
      <Footer />
    </v-main>
  </v-layout>
</template>

<script>
import { useDisplay } from "vuetify";
import { computed, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import Footer from "./Footer.vue";
import { useRoute, useRouter } from "vue-router";
export default {
  components: {
    Footer,
  },
  data: () => ({
    drawer: null,
    title: "ກົມເຕັກໂນໂລຊີດີຈີຕອນ",
    subtitle: "Department of Digital Technology",
    username: "Johnnie",
    items: [
      {
        menu_name: "ໜ້າຫຼັກ",
        icon: "mdi-home",
        route: "/",
      },
      // {
      //   menu_name: "ນິຕິກໍາ",
      //   icon: "mdi-chart-histogram",
      //   route: "/legislation",
      // },
      // {
      //   menu_name: "ກ່ຽວກັບພວກເຮົາ",
      //   icon: "mdi-folder-outline",
      //   route: "/about",
      // },
      {
        menu_name: "ຄົ້ນຫາໃບອະນຸຍາດ",
        icon: "mdi-tab-search",
        route: "/search",
      },
      {
        menu_name: "ເອກະສານທີ່ກ່ຽວຂ້ອງ",
        icon: "mdi-file-arrow-up-down",
        route: "",
        menus: [
          {
            menu_name: "ແບບຟອມ",
            icon: "mdi-newspaper",
            route: "/attachments",
          },
        ]
      },
      {
        menu_name: "ຕິດຕໍ່ພົວພັນ",
        icon: "mdi-newspaper",
        route: "/contact",
      },
    ],
    icons: ["mdi-facebook", "mdi-twitter", "mdi-linkedin", "mdi-instagram"],
  }),
  setup() {
    const store = useStore();
    const { width } = useDisplay();
    const route = useRoute();
    const drawer = ref(null);
    const hideMenu = ref(true);
    const hideImg = ref(true);
    /** */

    watch(width, (width) => {
      responsive(width);
    });

    onMounted(() => {
      responsive(width.value);
    });

    const responsive = (width) => {
      if (width < 940) {
        hideMenu.value = false;
        hideImg.value = false;
      } else {
        hideImg.value = true;
        hideMenu.value = true;
      }

      // if (width < 1200) {
      //   hideImg.value = false;
      // } else {
      //   hideImg.value = true;
      // }
    };

    return {
      route,
      drawer,
      hideMenu,
      hideImg,
    };
  },
};
</script>

<style scoped>
.btnStyle {
  background-color: rgb(var(--v-theme-white));
  color: rgb(var(--v-theme-black));
  font-weight: bold;
}

v-btn {
  font-weight: bold;
}

h3 {
  color: rgb(var(--v-theme-white));
}

.f-color {
  color: rgb(var(--v-theme-white));
}

.fontlao {
  font-family: phetsarath ot !important;
}
</style>
